"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var locals = {
  available: ["de", "en"],
  de: {
    fallbackInfo: {
      label: "Keine Webcams gefunden!"
    }
  },
  en: {
    fallbackInfo: {
      label: "No webcams found!"
    }
  }
};
var _default = locals;
exports.default = _default;